import React, { useEffect, useState } from 'react';
import AcceptedDocIcon from '../../svgs/AcceptedDocIcon';
import EmptyMerchantLogo from '../../svgs/EmptyMerchantLogo';
import PdfIcon from '../../svgs/PdfIcon';
import { capitalizeEverFirstLetter } from '../../utils/helpers';
import ViewFilePlain from './ViewFilePlain';

const getFileSize = (byte) => {
  // covert from byte to kb;
  if (!byte) return 0;
  const kb = byte / 1024;
  return Math.round(kb);
};
interface IPlainFile{
  docType?:any;
  onClick?:any;
  name?:string;
  fileSize?:any;
  imageType?:any;
  fileExt?:any;
  disabled?: boolean;
  documentUrl: string;
}
const PlainFile = ({
  docType, name, documentUrl, fileSize, imageType, fileExt, disabled,
}:IPlainFile) => {
  const Icon = AcceptedDocIcon;
  const [getDocType, setDocType] = useState('');
  const [CloseModal, setCloseModal] = useState(false);
  const [ShowActiveFile, setShowActiveFile] = useState('');
  const [loading, setLoading] = React.useState(false);
  const getExtension = (filename:any) => {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  };
  console.log(fileSize);
  const docChecker = () => {
    const ext = getExtension(docType);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':
      return setDocType('pdf');

    default:
      setDocType('pdf');
      break;
    }
  };

  const docCheckerFileExt = () => {
    const ext = getExtension(fileExt);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':

      return setDocType('pdf');

    default:
      break;
    }
  };
  const docCheckerImageType = () => {
    const ext = getExtension(imageType);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':

      return setDocType('pdf');

    default:
      break;
    }
  };

  useEffect(() => {
    if (docType) {
      docChecker();
    }
  }, [docType]);
  useEffect(() => {
    if (fileExt) {
      docCheckerFileExt();
    }
  }, [fileExt]);
  useEffect(() => {
    if (imageType) {
      docCheckerImageType();
    }
  }, [imageType]);

  const handleView = async (file) => {
    setCloseModal(true);
    setLoading(true);
    setLoading(false);
    setShowActiveFile(file);
  };

  const getFileComponent = () => (
    <div className="view-image-comp-cover">
      <div
        className="view-image-name"
        style={{
          ...(
            disabled ? { cursor: 'not-allowed' } : {}
          ),
        }}
      >
        {
          getDocType === 'image' ? docType ? <img src={documentUrl || docType} alt="logo" className="image" /> : <EmptyMerchantLogo /> : getDocType === 'pdf' ? <PdfIcon /> : <EmptyMerchantLogo />
        }
        <span>{name ? capitalizeEverFirstLetter(name)?.split?.('_')?.join(' ') : name || (docType ? 'Document' : 'No Logo Uploaded')}</span>

      </div>
      {disabled
        ? (
          <div
            className="file-upload-doc-btn"
          >

            <div
              className={`view-image-button ${docType ? 'active' : 'inactive'}`}
              style={{
                ...(
                  disabled ? { cursor: 'not-allowed', color: '#98A2B3' } : {}
                ),
              }}
            >
              View File
            </div>
            <div className="icon">
              <Icon />
            </div>
          </div>
        )
        : (
          <div
            className="file-upload-doc-btn"
          >
            <div className={`view-image-button ${docType ? 'active' : 'inactive'}`} onClick={() => handleView(documentUrl)}>View File</div>
            <div className="icon">
              <Icon />
            </div>
          </div>
        )}
    </div>
  );
  return (
    <div>
      {/* <img src={documentUrl} alt="working" /> */}
      <div>
        {getFileComponent()}
        <div className="file-size-cover">
          {' '}
          File size:
          {' '}
          {getFileSize(fileSize || 0)}
          {' '}
          Kb
        </div>
      </div>

      {
        CloseModal && (
        <ViewFilePlain
          loading={loading}
          fileType={getDocType}
          file={ShowActiveFile}
          handleClose={() => setCloseModal(false)}
          documentUrl={documentUrl}
        />
        )
      }
    </div>
  );
};
export default PlainFile;
